var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.daysData),function(dayActive,day){return _c('span',{key:day,staticClass:"schedule-days",class:[
            'schedule-days',
            dayActive ? 'active' : ''
        ]},[_vm._v(" "+_vm._s(day)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }